/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService'
import i18n from './i18n/i18n'
import precisoft from '@/http/requests/precisoft'
//import firebase from 'firebase/app'
//import 'firebase/auth'

Vue.use(Router)


import notificationsRouter from '@/views/app/notifications/routes/notificationsRoutes'
import warehouseRoutes from '@/views/app/warehouse/routes/warehouseRoutes'
import shelterFeeRoutes from '@/views/app/shelter-fee/routes/shelterFeeRoutes'
import hsbcRouters from './views/app/hsbc/routes/hsbcRouters'
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        // redirect: localStorage.getItem('permissions').includes('IU EHS Module') == true ? '/ehs/dashboard/':'/compliance/dashboard/',

        {
          path: '/',
          name: 'home',
          component: () => import('@/views/modules/dashboard/Index.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/ehs/dashboard',
          name: 'ehs_dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            rule: 'editor',
            authRequired: true,
            can: ['IU EHS VIEW'],
            breadcrumb: [
              {
                title: 'EHS Dashboard',
                active: true
              }
            ]
          }
        },
        {
          path: '/ehs_catalog/',
          name: 'Catalogo EHS',
          component: () => import('./views/apps/ehs_catolog/CatalogList.vue'),
          meta: {
            rule: 'editor',
            authRequired: true,
            can: ['IU EHS CATALOG VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: 'EHS Dashboard',
                url: '/ehs/dashboard'
              },
              {
                title: i18n.messages[i18n.locale].ehs_catalog,
                active: true
              }
            ]
          }
        },
        {
          path: '/gantt/annual_plan',
          name: 'app-gantt-graph',
          component: () => import('@/views/apps/gantt/GanttGraph.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'EHS Dashboard', url: '/ehs/dashboard' },
              { title: i18n.messages[i18n.locale].annual_plan, active: true }
            ],
            pageTitle: i18n.messages[i18n.locale].annual_plan,
            rule: 'editor'
          }
        },
        {
          path: '/ehs/:filter?',
          name: 'ehs-list',
          component: () => import('@/views/apps/ehs/EhsList.vue'),
          meta: {
            authRequired: true,
            can: ['IU EHS VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: 'EHS Dashboard',
                url: '/ehs/dashboard'
              },
              {
                title: 'EHS',
                active: true
              }
            ],
            pageTitle: 'EHS',
            rule: 'editor'
          },
          params: {
            status_id: ''
          }
        },
        {
          path: '/compliance/dashboard/',
          name: 'compliance_dashboard',
          component: () =>
            import('./views/apps/compliance/Compliance_Dashboard.vue'),
          meta: {
            rule: 'editor',
            authRequired: true,
            can: ['IU COMPLIANCE VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].compliance_dashboard,
                active: true
              }
            ]
          }
        },
        {
          path: '/compliance',
          name: 'compliance-list',
          component: () => import('@/views/apps/compliance/ComplianceList.vue'),
          meta: {
            authRequired: true,
            can: ['IU COMPLIANCE VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].compliance_dashboard,
                url: '/compliance/dashboard'
              },
              {
                title: i18n.messages[i18n.locale].compliance_sidemenu,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].compliance_sidemenu,
            rule: 'editor'
          }
        },
        {
          path: '/contralor',
          name: i18n.messages[i18n.locale].contralor,
          component: () => import('@/views/apps/invoices/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU CONTRALOR VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].contralor,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].contralor,
            rule: 'editor'
          }
        },
        {
          path: '/contralor/report',
          name: i18n.messages[i18n.locale].sidebar_contralor_report,
          component: () => import('@/views/apps/invoices/ContralorReport.vue'),
          meta: {
            authRequired: true,
            can: ['IU CONTRALOR VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].contralor,
                url: '/contralor'
              },
              {
                title: i18n.messages[i18n.locale].sidebar_contralor_report,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].sidebar_contralor_report,
            rule: 'editor'
          }
        },
        {
          path: '/contralor/config',
          name: i18n.messages[i18n.locale].sidebar_contralor_config,
          component: () => import('@/views/apps/invoices/ContralorConfig.vue'),
          meta: {
            authRequired: true,
            can: ['IU CONTRALOR VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].contralor,
                url: '/contralor'
              },
              {
                title: i18n.messages[i18n.locale].sidebar_contralor_config,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].sidebar_contralor_config,
            rule: 'editor'
          }
        },
        {
          path: '/cash_request',
          name: 'cash_request',
          component: () => import('@/views/apps/cash_request/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU CASH REQUEST VIEW'],
            breadcrumb: [
              {
                title: 'Cash Request',
                active: true
              }
            ],
            pageTitle: 'Cash Request',
            rule: 'editor'
          }
        },
        {
          path: '/accounting',
          name: 'accounting',
          component: () => import('@/views/apps/accounting/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU ACCOUNTING VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].accounting,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/expenses',
          name: 'expenses',
          component: () => import('@/views/apps/expense/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU ACCOUNTING VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].expenses,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].expenses,
            rule: 'editor'
          }
        },
        {
          path: '/tax_return',
          name: 'tax_return',
          component: () => import('@/views/apps/accounting/TaxReturnIndex.vue'),
          meta: {
            authRequired: true,
            can: ['IU TAX RETURN VIEW'],
            breadcrumb: [
              {
                title: 'Tax Return',
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/bank_statements',
          name: 'bank_statements',
          component: () => import('@/views/apps/bank_statement/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU BANK STATEMENT VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].bank_statements,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/blacklist',
          name: 'blacklist',
          component: () => import('@/views/apps/blacklist/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU BLACKLIST VIEW'],
            breadcrumb: [
              {
                title: 'Blacklist',
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/bi_report',
          name: 'bi_report',
          component: () => import('@/views/apps/accounting/BiReport.vue'),
          meta: {
            authRequired: true,
            can: ['IU ACCOUNTING VIEW'], //IU ACCOUNTING BI REPORT
            breadcrumb: [
              {
                title: 'Bi Report',
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/payroll',
          name: 'payroll',
          component: () => import('@/views/apps/payroll/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU PAYROLL VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].payroll,
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/bonus/home',
          name: 'bonus-home',
          component: () => import('@/views/app/bonus/home/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU BONUS VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: i18n.messages[i18n.locale].bonus, url: '/home', active: true },
            ]
          }
        },
        {
          path: '/bank_accounts',
          name: 'bank_accounts',
          component: () => import('@/views/apps/bank_account/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU BANK ACCOUNT VIEW'],
            breadcrumb: [
              {
                title: 'Bank accounts',
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/recipients',
          name: 'recipients',
          component: () => import('@/views/apps/recipient/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU RECIPIENT VIEW'],
            breadcrumb: [
              {
                title: 'Recipients',
                active: true
              }
            ],
            pageTitle: i18n.messages[i18n.locale].accounting,
            rule: 'editor'
          }
        },
        {
          path: '/clients',
          name: 'clients',
          component: () => import('@/views/apps/client/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU CLIENT VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].clients,
                active: true
              }
            ]
          }
        },
        {
          path: '/clients/add',
          name: 'add-client',
          component: () => import('@/views/apps/client/AddClient.vue'),
          meta: {
            authRequired: true,
            can: ['IU CLIENT VIEW'],
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].clients, url: '/clients' },
              { title: i18n.messages[i18n.locale].add, active: true }
            ]
          }
        },
        {
          path: '/clients/:id',
          name: 'client-details',
          component: () => import('@/views/apps/client/ClientDetails.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU CLIENT VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].clients, url: '/clients' },
              { title: i18n.messages[i18n.locale].details, active: true }
            ]
          }
        },
        {
          path: '/entries',
          name: 'entries',
          component: () =>
            import('@/views/modules/import_export/entry/Index.vue'),
          meta: {
            authRequired: true,
            can: ['IU ENTRY VIEW'],
            breadcrumb: [
              {
                title: i18n.messages[i18n.locale].sidebar_entries,
                active: true
              }
            ],
            pageTitle: 'Entries',
            rule: 'editor'
          }
        },
        {
          path: '/entries/:id',
          name: 'entry-details',
          component: () =>
            import('@/views/modules/import_export/entry/Details.vue'),
          meta: {
            authRequired: true,
            can: ['IU ENTRY VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_entries,
                url: '/entries'
              },
              { title: i18n.messages[i18n.locale].details, active: true }
            ],
            pageTitle: 'Entries',
            rule: 'editor'
          }
        },
        {
          path: '/review_orders',
          name: 'review-order',
          component: () =>
            import('@/views/modules/import_export/review_order/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU REVIEW ORDER VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_review_orders,
                active: true
              }
            ]
          }
        },
        {
          path: '/review_orders/create',
          name: 'create-review-order',
          component: () =>
            import('@/views/modules/import_export/review_order/Create.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU REVIEW ORDER VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_review_orders,
                url: '/review_orders'
              },
              { title: i18n.messages[i18n.locale].create, active: true }
            ]
          }
        },
        {
          path: '/review_orders/:id',
          name: 'review-order-details',
          component: () =>
            import('@/views/modules/import_export/review_order/Details.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU REVIEW ORDER VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_review_orders,
                url: '/review_orders'
              },
              { title: i18n.messages[i18n.locale].details, active: true }
            ]
          }
        },
        {
          path: '/update_txt/ro/:id',
          name: 'review-order-details-update-txt',
          component: () =>
            import(
              '@/views/modules/import_export/review_order/ReviewOrderUpdateTxT.vue'
            ),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU REVIEW ORDER EDIT'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_review_orders,
                url: '/review_orders'
              },
              { title: i18n.messages[i18n.locale].details, active: true }
            ]
          }
        },
        {
          path: '/load_orders',
          name: 'load-orders',
          component: () =>
            import('@/views/modules/import_export/load_order/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU LOAD ORDER VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_load_order,
                url: '/load_orders',
                active: true
              }
            ]
          }
        },
        {
          path: '/load_orders/create/:load_order_id?',
          name: 'load-orders-create',
          component: () =>
            import('@/views/modules/import_export/load_order/Create.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_load_order,
                url: '/load_orders'
              },
              { title: i18n.messages[i18n.locale].create, active: true }
            ]
          }
        },
        {
          path: '/load_orders/:id',
          name: 'load-order-details',
          component: () =>
            import('@/views/modules/import_export/load_order/Details.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU LOAD ORDER VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_load_order,
                url: '/load_orders'
              },
              { title: i18n.messages[i18n.locale].details, active: true }
            ]
          }
        },
        {
          path: '/discrepancies',
          name: 'discrepancies',
          component: () =>
            import('@/views/modules/import_export/discrepancy/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU DISCREPANCY VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: i18n.messages[i18n.locale].sidebar_discrepancy,
                active: true
              }
            ]
          }
        },
        {
          path: '/vendors',
          name: 'vendors',
          component: () => import('@/views/modules/vendors/home/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU VENDORS VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].vendor, url: '/vendors', active: true },
            ]
          }
        },

        {
          path: '/vendors/detail/:id',
          name: 'vendors-detail',
          component: () => import('@/views/modules/vendors/details/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU VENDORS VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].vendor, url: '/vendors', active: true },
              { title: i18n.messages[i18n.locale].details, url: '/vendors/detail', active: true },
            ]
          }
        },
        {
          path: '/salary_survey',
          name: 'salary-survey',
          component: () => import('@/views/modules/human_resource/salary_survey/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU SALARY SURVEY VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: "Salary Survey", url: '/salary_survey', active: true },
            ]
          }
        },
        {
          path: '/salary_comparison',
          name: 'salary-comparison',
          component: () => import('@/views/modules/human_resource/salary_comparation/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU SALARY COMPARISON VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: "Salary Comparison", url: '/salary_comparison', active: true },
            ]
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/views/modules/custom_dashboard/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            //can: ['IU VENDORS VIEW'],
            /* breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].vendor, url: '/vendors', active: true},
            ] */
          }
        },
        {
          path: '/dashboard/settings',
          name: 'dashboard-settings',
          component: () => import('@/views/modules/custom_dashboard/Edit.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            //can: ['IU VENDORS VIEW'],
            /* breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].vendor, url: '/vendors', active: true},
            ] */
          }
        },
        {
          path: '/mail_server',
          name: 'mail_server',
          component: () => import('@/views/modules/mail_server/index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU MAIL SERVER VIEW'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].mail_server, url: '/mail_server', active: true },
            ]
          }
        },

        {
          path: '/repse/documents',
          name: 'repse-documents',
          component: () => import('@/views/modules/repse/documents/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU Repse'],
            breadcrumb: [
              { title: 'Home', url: '/home' },
              { title: 'REPSE', url: '/repse' },
              { title: i18n.messages[i18n.locale].documents, url: '/repse/documents', active: true },
            ]
          }
        },
        {
          path: '/repse',
          name: 'repse',
          component: () => import('@/views/modules/repse/vendors/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU Repse'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'REPSE', url: '/repse' },
              { title: i18n.messages[i18n.locale].vendors, url: '/repse', active: true },
            ]
          }
        },
        {
          path: '/repse/vendor/:id/documentation',
          name: 'repse-documentation',
          component: () => import('@/views/modules/repse/vendors/RepseDocumentation.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU Repse'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'REPSE', url: '/repse' },
              { title: i18n.messages[i18n.locale].documentation, url: '/', active: true },
            ]
          }
        },
        {
          path: '/repse/documentation/:id/requests',
          name: 'repse-requests',
          component: () => import('@/views/modules/repse/vendors/RepseRequests.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU Repse'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'REPSE', url: '/repse' },
              { title: i18n.messages[i18n.locale].requests, url: '/', active: true },
            ]
          }
        },
        {
          path: '/hsbc',
          name: 'hsbc',
          component: () => import('@/views/modules/hsbc/home/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU HSBC'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].hsbc, url: '/hsbc', active: true },
            ]
          }
        },
        {
          path: '/budget/departament',
          name: 'budget-departament-list',
          component: () => import('@/views/modules/budget/departament/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU BUDGET'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].budget, url: '/budget/departament', active: true },
            ]
          },
        },
        {
          path: '/budget/assign',
          name: 'budget-assign',
          component: () => import('@/views/modules/budget/assign/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU BUDGET'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].budget, url: '/budget/assign', active: true },
            ]
          },
        },
        {
          path: '/budget-category',
          name: 'budget-category',
          component: () => import('@/views/modules/budget/budget-category/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU BUDGET'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].budget, url: '/budget-category', active: true },
            ]
          }
        },
        {
          path: '/budget-departament',
          name: 'budget-departament',
          component: () => import('@/views/modules/budget/budget-departament/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU BUDGET'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].budget, url: '/budget-departament', active: true },
            ]
          },
        },
        {
          path: '/budget-subtotals',
          name: 'budget-subtotals',
          component: () => import('@/views/modules/budget/subtotals/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU BUDGET'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].budget, url: '/budget-subtotals', active: true },
            ]
          },
        },
        {
          path: '/purchase-orders',
          name: 'purchase-orders',
          component: () => import('@/views/modules/po/home/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU PO'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].purchase_orders, url: '/po', active: true },
            ]
          },
        },
        {
          path: '/expense/automatic',
          name: 'automatic-expense',
          component: () => import('@/views/modules/automatic_expense/home/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU EXPENSE AUTO'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].vendors, url: '/expense/automatic', active: true },
            ]
          },
        },
        // {
        //   path: '/hsbc-logs',
        //   name: 'hsbc-logs',
        //   component: () => import('@/views/modules/hsbc/logs/Index.vue'),
        //   meta: {
        //     authRequired: true,
        //     rule: 'editor',
        //     can: ['IU HSBC'],
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: i18n.messages[i18n.locale].hsbc_logs, url: '/hsbc_logs', active: true},
        //     ]
        //   }
        // },
        {
          path: '/notifications/recruitment',
          name: 'notifications-recruitment',
          component: () => import('@/views/modules/notifications/recruitment/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU Repse'],
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].notifications, url: '/notifications/recruitment', active: true },
            ]
          }
        },
        //  {
        //   path: '/treasury/accounts',
        //   name: 'treasury-accounts',
        //   component: () => import('@/views/modules/treasury/accounts/Index.vue'),
        //   meta: {
        //     authRequired: true,
        //     rule: 'editor',
        //     can: ['IU HSBC'],
        //     breadcrumb: [
        //       { title: 'Home', url: '/home' },
        //       { title: i18n.messages[i18n.locale].accounts, url: '/treasury/accounts', active: true },
        //     ]
        //   }
        // },
        // {
        //   path: '/test',
        //   name: 'test',
        //   component: () => import('@/views/Test.vue'),
        //   meta: {
        //     rule: 'editor',
        //   },
        // },
        {
          path: 'cells',
          name: 'cells',
          component: () => import('@/views/modules/dashboard/cells/Index.vue'),
          meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU CELL EDIT'],
            rule: 'editor',
          },
        },
        {
          path: '/not-authorized',
          name: 'not-authorized',
          component: () => import('./views/NotAuthorized.vue'),
          meta: {
            //can:true,
            authRequired: true,
            rule: 'editor'
          }
        },
        {
          path: '/digizen',
          name: 'digizen',
          meta: {
            authRequired: true,
            rule: 'editor',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: i18n.messages[i18n.locale].load_orders, active: true }
            ]
          },
          beforeEnter() {
            const url =
              'https://digizen.tacna.net/index.php/login?remember_login=1&directLogin=1'
            window.open(
              url,
              'winname',
              'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes'
            )
          }
        },
        {
          path: '/precisoft',
          name: 'precisoft',
          meta: {
            authRequired: true,
            rule: 'editor',
          },
          beforeEnter() {
            precisoft
              .getToken()
              .then(res => {
                const url = res.data.url
                window.open(
                  url,
                  'winname',
                  'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes'
                )
              })
              .catch(err => {
                console.log(err)
              })
          }
        },
        ...notificationsRouter,
        ...warehouseRoutes,
        ...shelterFeeRoutes,
        ...hsbcRouters
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/callback',
          name: 'auth-callback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/reset-password/:token',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    },
    //layout dark to dashboard tv
    {
      path: '',
      component: () => import('@/layouts/dark-page/DarkPage.vue'),
      children: [
        {
          path: '/dashboard-tv',
          name: 'dashboardtv',
          component: () => import('@/views/modules/dashboard/fullScreen/Index.vue'),
          meta: {
            rule: 'editor',
          },
        }
      ]
    },

  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.authRequired) {
    if (!auth.isAuthenticated()) {
      router.push({
        path: '/login'
      })
    }

    if (to.meta.can !== undefined) {
      if (!hasPermission(to.meta.can)) {
        router.push({
          path: '/not-authorized'
        })
      }
    }
  }
  if (to.name === 'login' && auth.isAuthenticated()) {
    router.push({
      path: '/',
      query: {
        to: to.path
      }
    })
  }
  return next()
})

function hasPermission(list) {
  let hasPermission = false
  const permissions = JSON.parse(localStorage.getItem('permissions'))
  if (permissions) {
    list.forEach(element => {
      if (permissions.indexOf(element) >= 0) {
        hasPermission = true
      }
    })
  }
  return hasPermission
}

function getHomePage() {
  //console.log('permisos',JSON.parse(localStorage.getItem('permissions')));
  return import('@/views/modules/custom_dashboard/Index.vue')
  // if (hasPermission(['IU EHS VIEW'])) {
  //   return import('@/views/Dashboard.vue')
  // }
  // if (hasPermission(['IU COMPLIANCE VIEW'])) {
  //   return import('@/views/apps/compliance/Compliance_Dashboard.vue')
  // }
  // if (hasPermission(['IU CONTRALOR VIEW'])) {
  //   return import('@/views/apps/invoices/Index.vue')
  // }
  // if (hasPermission(['IU CASH REQUEST VIEW'])) {
  //   return import('@/views/apps/cash_request/Index.vue')
  // }
  // if (hasPermission(['IU ACCOUNTING VIEW'])) {
  //   return import('@/views/apps/accounting/Index.vue')
  // }
  // return import('@/views/NotAuthorized.vue')
}


export default router
